module.exports = __webpack_public_path__ + "static/img/美的M60系列.542d1725.png";